<template>
  <div class="view-adminusercreate">
    <div class="breadcrump-trail">
      <router-link :to="{ name: 'admin-home' }"> Admin </router-link> /
      <router-link :to="{ name: 'admin-users-list' }"> Nutzer </router-link>
      / <span> Nutzer erstellen</span>
    </div>

    <h1>Nutzer erstellen</h1>

    <admin-user-form
      :field-errors="fieldErrors"
      :submit-label="$t('actions.createUser')"
      @submit="onSubmit"
    />
  </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import { useRouter } from "vue-router";
import { useAdmin } from "./useAdmin";

import AdminUserForm from "./AdminUserForm.vue";
import { showError } from "@core/ui/alert/alert";
import { BadRequestError } from "@core/errors/Errors";

import type { User } from "@/api/User";

const router = useRouter();
const adminAPI = useAdmin();

const fieldErrors = reactive({
  email: undefined as string | undefined,
  name: undefined as string | undefined
});

async function onSubmit(userData: Partial<User>) {
  // create user
  try {
    const user = await adminAPI.post<User>("/users", {
      data: userData
    });
    router.push({
      name: "admin-users-update",
      params: {
        userId: user.id
      }
    });
  } catch (_error) {
    const error = _error as Error | BadRequestError;
    if ("fields" in error) {
      for (const _field in fieldErrors) {
        const field = _field as keyof typeof fieldErrors;
        fieldErrors[field] = error.fields[field];
      }
    } else {
      showError(error);
    }
  }
}
</script>

<style lang="scss">
.view-adminusercreate {
  padding: 2rem;
  max-width: 75rem;
  width: 100%;
}
</style>
